import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { NEUROLYTICS_API } from 'utils/environment-variables';
import { auth0Client } from 'Auth';

export interface PaginatedBackendResponse<T> {
    items: T[];
    count: number;
    total?: number;
    currentPage?: number;
    totalPages?: number;
    nextToken?: string;
}

const getAuthToken = async () => {
    if (auth0Client) {
        try {
            return await auth0Client.getTokenSilently();
        } catch (error) {
            throw error;
        }
    }
    return null;
};

export const api = createApi({
    reducerPath: 'api',
    baseQuery: fetchBaseQuery({
        baseUrl: NEUROLYTICS_API,
        prepareHeaders: async (headers) => {
            const token = await getAuthToken();
            if (token) {
                headers.set('Authorization', `Bearer ${token}`);
            }
            headers.set('Content-Type', 'application/json');
            return headers;
        },
    }),
    tagTypes: [
        'Company',
        'Participant',
        'ParticipantActivity',
        'ParticipantFeedback',
        'ParticipantsActivity',
        'Group',
        'GroupWorkPreferencesBaseline',
        'ScanTemplate',
        'ParticipantEmailInfo',
        'SendParticipantEmails',
    ],
    endpoints: () => ({}),
});
